import { Skeleton } from '@/components/ui/skeleton';

function ChartSkeleton() {
	return (
		<div className='rounded-xl border border-border bg-card shadow-sm overflow-hidden'>
			<div className='border-b px-4 py-3 flex items-center gap-2'>
				<Skeleton className='h-7 w-7 rounded-lg' />
				<Skeleton className='h-4 w-24' />
			</div>
			<div className='px-2 py-3'>
				<Skeleton className='h-[180px] w-full rounded-lg' />
			</div>
		</div>
	);
}

interface ProfileStatsSkeletonProps {
	showHero?: boolean;
	showPeriodFilter?: boolean;
}

export function ProfileStatsDataSkeleton() {
	return (
		<>
			<div className='grid grid-cols-2 gap-2'>
				{Array.from({ length: 4 }).map((_, i) => (
					<div key={i} className='rounded-md border border-border bg-card p-3.5 flex flex-col gap-2'>
						<Skeleton className='h-3 w-16' />
						<Skeleton className='h-5 w-12' />
					</div>
				))}
			</div>

			<Skeleton className='h-4 w-56 mx-auto' />

			<div className='flex flex-wrap gap-2'>
				<Skeleton className='h-7 w-36 rounded-full' />
				<Skeleton className='h-7 w-36 rounded-full' />
			</div>

			<ChartSkeleton />
			<ChartSkeleton />
			<ChartSkeleton />

			<div className='rounded-xl border border-border bg-card shadow-sm overflow-hidden'>
				<div className='border-b px-4 py-3 flex items-center gap-2'>
					<Skeleton className='h-7 w-7 rounded-lg' />
					<Skeleton className='h-4 w-32' />
				</div>
				<div className='px-4 py-2 flex flex-col gap-3'>
					{Array.from({ length: 4 }).map((_, i) => (
						<div key={i} className='flex items-center justify-between py-2'>
							<Skeleton className='h-4 w-16' />
							<Skeleton className='h-3 w-20' />
						</div>
					))}
				</div>
			</div>
		</>
	);
}

export default function ProfileStatsSkeleton({ showHero = true, showPeriodFilter = true }: ProfileStatsSkeletonProps) {
	return (
		<div className='flex flex-col gap-4'>
			{showHero && (
				<div className='rounded-xl border border-border p-5 flex flex-col gap-2'>
					<Skeleton className='h-3 w-28' />
					<Skeleton className='h-9 w-32' />
					<Skeleton className='h-4 w-48' />
				</div>
			)}

			{showPeriodFilter && (
				<div className='grid grid-cols-4 gap-1'>
					{Array.from({ length: 4 }).map((_, i) => (
						<Skeleton key={i} className='h-9 rounded-md' />
					))}
				</div>
			)}

			<ProfileStatsDataSkeleton />
		</div>
	);
}
